// extracted by mini-css-extract-plugin
export default {"panel":"SidePanel_panel__39JSN","open":"SidePanel_open__kA9Td"};